module.exports = __webpack_public_path__ + "static/media/photo.5d2ad5fa.jpeg";